export function flaggedMetadataAddIssue() {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'FLAGGED_METADATA_ADD_ISSUE',
            })
        );
}

export function flaggedMetadataDeleteIssue(issueId) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                issueId,
                type: 'FLAGGED_METADATA_DELETE_ISSUE',
            })
        );
}

export function flaggedMetadataSetActive(
    active,
    roviProgramId,
    servicesDataKey,
    onSuccessCallbacks,
    echostarId,
    tmsId,
    sourceId
) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                active,
                echostarId,
                onSuccessCallbacks,
                roviProgramId,
                servicesDataKey,
                sourceId,
                tmsId,
                type: 'FLAGGED_METADATA_SET_ACTIVE',
            })
        );
}

export function flaggedMetadataSaveComments(issueId) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                issueId,
                type: 'FLAGGED_METADATA_SAVE_COMMENTS',
            })
        );
}

export function flaggedMetadataReset() {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'FLAGGED_METADATA_RESET',
            })
        );
}

export function flaggedMetadataCompleteFlagging(onSuccess) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                onSuccess,
                type: 'FLAGGED_METADATA_SUBMIT_POST',
            })
        );
}
